import { render, staticRenderFns } from "./WebsitePublicPlaceEditListHeader.vue?vue&type=template&id=b50fbb06&scoped=true&lang=pug"
import script from "./WebsitePublicPlaceEditListHeader.vue?vue&type=script&lang=ts"
export * from "./WebsitePublicPlaceEditListHeader.vue?vue&type=script&lang=ts"
import style0 from "./WebsitePublicPlaceEditListHeader.vue?vue&type=style&index=0&id=b50fbb06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50fbb06",
  null
  
)

export default component.exports